<template>
  <div class="adv-bg">
    <div class="notFound-wrapper">
      <div class="notFound_content">
        <h1 class="text-white">
          Page Not Found.go to
          <router-link to="/dashboard"> Dashboard </router-link>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.notFound-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
</style>